import {Modal} from "react-bootstrap";
import React, {Fragment, useContext, useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'
import NsModalHeader from "../../../components/modal/NsModalHeader";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import {visualizzaAnteprimaFile} from "../../../utility/common";
import {LoaderContext} from "../../../context/LoaderContext";
import ModalMsg from "../../../components/ModalMsg";
import {getDocumentoArchivioByIdApi} from "../../../services/ArchivioServices";
import {Link} from "react-router-dom";

function ModalDocumentiArchivioCert({
                                        show,
                                        handleClose,
                                        documentiArchivio,
                                        marca,
                                        modello,
                                        tipo_motore,
                                        errore,
                                    }) {

    const [showModalMsg, setShowModalMsg] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    useEffect(() => {
    }, [documentiArchivio]);

    const visualizzaDocumento = async (doc) => {
        startChiamata();

        var response = await getDocumentoArchivioByIdApi(doc.id_archivio_documento);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShowModalMsg(true)
        } else {
            let resp = response.data.data;
            if (resp) {
                const contentType = resp.content_type;
                const base64Data = resp.contenuto;

                visualizzaAnteprimaFile(base64Data, contentType);
            }
        }
        endChiamata();
    }

    function getMessaggioNoDocumentiArchivio() {
        if (marca && marca !== '' && modello && modello !== '' && tipo_motore && tipo_motore !== '') {
            return `Non sono presenti documenti in archivio per ${marca} ${modello} con motore ${tipo_motore}`;
        } else {
            return `Valorizzare Marca veicolo, Tipo e Anno di costruzione per verificare la presenza di documenti in archivio`;
        }
    }

    return (
        <Fragment>
            <ModalMsg
                show={showModalMsg}
                handleClose={() => setShowModalMsg(false)}
                testo={modalMsg}
            />
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size={"xl"}
            >
                <NsModalHeader title={"Documenti in archivio"}/>
                <Modal.Body>
                    {
                        errore ?
                            <h4>{errore}</h4>
                        : documentiArchivio === null ?
                            <div className="text-center py-3">
                                <i className="fas fa-spinner fa-spin fa-2x"/>
                            </div>
                        : documentiArchivio?.length > 0 ?
                        <NsDataTable
                            data={documentiArchivio}
                            columns={[
                                {
                                    name: 'Titolo',
                                    selector: row => row.titolo,
                                    sortable: true,
                                },
                                {
                                    name: 'Tema',
                                    selector: row => row.tema || '-',
                                    sortable: true,
                                },
                                {
                                    name: 'Anno documento',
                                    selector: row => row.anno_doc || '-',
                                    sortable: true,
                                },
                                {
                                    name: '',
                                    selector: row => <Fragment>
                                        <Link to={`/documento-archivio/${row.id_archivio_documento}`}
                                              target="_blank"
                                              className="btn btn-sm btn-dark"
                                              data-toggle="tooltip"
                                              title="Visualizza"
                                        >
                                            <i className="fas fa-eye"/> Visualizza
                                        </Link>
                                    </Fragment>,
                                    sortable: false,
                                    right: true,
                                }
                            ]}
                            addPagination={true}
                            funzioneFiltro={(item, filtro) => {
                                return (item.titolo && item.titolo.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.tema && item.tema.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.anno_doc && item.anno_doc.toLowerCase().includes(filtro.toLowerCase()))
                            }}
                        />
                            :
                            <h4>{getMessaggioNoDocumentiArchivio()}</h4>
                    }
                </Modal.Body>
            </Modal>
        </Fragment>
    )

}

export default ModalDocumentiArchivioCert;